<template>
  <v-container class="ma-0 pa-0 px-2">
    <!-- Title -->
    <v-row no-gutters align="center">
      <v-col v-if="params.professional" no-gutters cols="12"
        class="pa-0 ma-0 py-8 title text-center" align-self="center" justify-self="center" >
        Agendas não encontradas
      </v-col>
      <v-col v-else no-gutters cols="12"
        class="pa-0 ma-0 py-8 title text-center" align-self="center" justify-self="center">
        Profissional não encontrado
      </v-col>
    </v-row>
    <!-- Message -->
    <v-row no-gutters v-if="params.professional" class="pa-0 py-2 ma-0">
      <v-col no-gutters cols="12" class="pa-0 ma-0 text-center">
        <span class="font-weight-bold">{{params.professional.professionalName}}</span>
        não possui horários para agendamento no momento.
      </v-col>
      <v-col no-gutters cols="12" class="pa-0 ma-0 text-center">
        Deseja ser avisado quando o profissional tiver horários disponíveis?
      </v-col>
    </v-row>

    <v-row no-gutters v-else-if="params.speciality" class="pa-0 py-2 ma-0">
      <v-col no-gutters cols="12" class="pa-0 ma-0 text-center">
        Não foram encontrados profissionais de
        <span class="font-weight-bold">{{params.speciality.name}}</span>.
      </v-col>
      <v-col no-gutters cols="12" class="pa-0 ma-0 text-center">
        Deseja ser avisado quando houver profissional disponível?
      </v-col>
    </v-row>
    <!-- Buttons -->
    <v-row no-gutters justify="center" class="mt-10 text-center">
      <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="12" class="pb-5">
       <mb-text-button name="schr_reminder"
          @click="reminder"
          :loading="reminderLoding"
          :disabled="disableReminderButton"
          label="Me avise"
        />
      </v-col>

      <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="12">
        <mb-text-button name="schr_new_search"
          @click="newSearch"
          :primary="false"
          label="Nova busca"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import MbTextButton from '@/components/general/buttons/MbTextButton';

export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    reminderLoding: false,
    disableReminderButton: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  methods: {
    newSearch() {
      this.$router.push({ name: 'calendar-filter' });
    },
    reminder() {
      this.reminderLoding = true;

      const parameters = { ...this.params };

      if (parameters.professional) {
        parameters.professionalId = parameters.professional.id;
      }

      if (parameters.covenant) {
        parameters.covenantId = parameters.covenant.covenantId;
      }

      if (parameters.speciality) {
        parameters.specialityId = parameters.speciality.id;
      }

      if (parameters.serviceChannel && parameters.serviceChannel.id != -1) {
        parameters.serviceChannelId = parameters.serviceChannel.id;
      }

      if (parameters.distance) {
        parameters.distanceStart = 0;
        parameters.distanceEnd = parameters.distance;
      }

      if (parameters.weekdays) {
        parameters.weekdays = parameters.weekdays.join();
      }

      delete parameters.patient;
      delete parameters.particular;
      delete parameters.professional;
      delete parameters.covenant;
      delete parameters.speciality;
      delete parameters.serviceChannel;
      delete parameters.distance;

      this.$store
        .dispatch('patientSchedules/saveReminder', { patientId: this.user.id, parameters })
        .then(() => {
          bus.$emit('message', {
            message: 'Ok! Avisaremos quando disponível',
            type: 'success',
          });
          this.disableReminderButton = true;
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.reminderLoding = false;
        });
    },
  },
  components: {
    MbTextButton,
  },
};
</script>
